import PaymentConfirmation from './PaymentConfirmation';
import withRedirect from './enhancers/withRedirect';

export {
  withRedirect,
  PaymentConfirmation as default,
};
